import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageLeftColumn } from 'components/page/sections/page-section-two-columns-image-left-column';
import {
  SectionContentLinkList,
  SectionContentLinkListIdFive,
} from 'components/section-content-link-list';

export const TabFiveContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdFive.RightToBeInformed,
      text: sections.tabFiveSection.tab.contents.item1(),
    },
    {
      id: SectionContentLinkListIdFive.RightToAccess,
      text: sections.tabFiveSection.tab.contents.item2(),
    },
    {
      id: SectionContentLinkListIdFive.RightToRectify,
      text: sections.tabFiveSection.tab.contents.item3(),
    },
    {
      id: SectionContentLinkListIdFive.RightToDataPortability,
      text: sections.tabFiveSection.tab.contents.item4(),
    },
    {
      id: SectionContentLinkListIdFive.RightToErase,
      text: sections.tabFiveSection.tab.contents.item5(),
    },
    {
      id: SectionContentLinkListIdFive.RightToRestrictOrObject,
      text: sections.tabFiveSection.tab.contents.item6(),
    },
    {
      id: SectionContentLinkListIdFive.RightToComplain,
      text: sections.tabFiveSection.tab.contents.item7(),
    },
    {
      id: SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking,
      text: sections.tabFiveSection.tab.contents.item8(),
    },
    {
      id: SectionContentLinkListIdFive.HowDoYouEnforceYourRights,
      text: sections.tabFiveSection.tab.contents.item9(),
    },
    {
      id: SectionContentLinkListIdFive.DoYouLiveInCalifornia,
      text: sections.tabFiveSection.tab.contents.item10(),
    },
  ];
  const props = {
    title: sections.tabFiveSection.tab.title(),
    subTitle: sections.tabFiveSection.tab.text(),
    image: {
      src: `${CdnImagePath}/assets/tab-05/tab-05-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
    columnRight: {
      title: sections.tabFiveSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
  };

  return <PageSectionTwoColumnsImageLeftColumn {...props} />;
};
